import { useTrustpilotScript } from '@/hooks/use-trustpilot-script';
import React, { useEffect } from 'react';

const Trustpilot = () => {
  const ref = React.useRef<HTMLDivElement | null>(null);
  const { onLoaded, initializeWidget } = useTrustpilotScript();
  useEffect(() => {
    onLoaded(() => {
      initializeWidget(ref.current);
    });
  }, [onLoaded, initializeWidget]);

  return (
    <div
      ref={ref}
      className="trustpilot-widget"
      data-locale="en-AU"
      data-template-id="54ad5defc6454f065c28af8b"
      data-businessunit-id="58dc83630000ff00059f7d50"
      data-style-height="240px"
      data-style-width="100%"
      data-theme="dark"
      data-tags="SelectedReview"
      data-review-languages="en"
    >
      <a
        href="https://www.trustpilot.com/review/exetel.com.au"
        target="_blank"
        rel="noopener noreferrer"
      >
        Trustpilot
      </a>
    </div>
  );
};
export { Trustpilot };
